<template>
    <div style="background-color: #EEEBE7;">
        <div class="table-tr-content" :class="classes" style="padding:30px; display:flex; align-items:center; justify-content: space-between;">
            <div class="table-td status status-success parcel-arrived-text" :class="{'parcel-arrived-text-orange' : !delivered}">
                <i class="fa fa-long-arrow-right right-icon right-icon-circle" aria-hidden="true" v-if="!delivered"></i>
                <i class="fa fa-check-circle parcel-arrived-icon" v-else></i>
                <span>
                    <span v-if="!extendActivity">{{ $helper.trans('Parcel') }}</span>
                    <span v-if="extendActivity">{{ parcel.tracking_number }}</span>
                    <span v-else>{{ trackingNumber }}</span>
                    <span v-if="extendActivity">{{ parcel.final_status }}</span>
                    <span v-else>{{ trackingStatus }}</span>
                </span>
            </div>
            <div v-if="!$helper.empty(estimatedDelivery) && !delivered">
                <div class="table-td status estimated_delivery"> 
                    <span>{{ $helper.trans('Estimated_delivery_date') }}: {{ estimatedDelivery }}</span>
                </div>
            </div>
            <button v-if="extendActivity && !activityOpened" class="btn btn-yellow btn-packet radius-4" @click="activityOpened = true">{{ $helper.trans('Show_summary') }}</button>
        </div>
        <div class="toggle-wrap tracking-summary custom-tracking-summary-wrap d-block" v-if="extendActivity && activityOpened">
            <div class="toggle-content p-0">
                <div class="toggle-packet-content mt-0 pt-0">
                    <div class="toggle-column-big">
                        <activity-history-component
                            :parcel="parcel"
                        ></activity-history-component>
                        <button class="btn btn-yellow close-btn" @click="activityOpened = false">{{ $helper.trans('Close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            activityOpened: false,
        }
    },
    props:{
        delivered: {
            type: Boolean,
            require: false,
            default: false,
        },
        trackingNumber: {
            type: String,
            require: true,
        },
        trackingStatus: {
            type: String,
            require: true,
        },
        estimatedDelivery: {
            type: String,
            require: false,
            default: '',
        },
        classes: {
            type: String,
            require: false,
            default: '',
        },
        extendActivity: {
            type: Boolean,
            require: false,
            default: false,
        },
        parcel: {
            type: Object,
            required: false,
            default: function(){
                return {};
            },
        }
    }
}
</script>
